/* Shared Academy discipline theming + progress helpers.
   One theme system: the discipline decides colour, glow, focus, buttons. */

/* Shared interaction states for every primary discipline button. */
export const BTN_FX = "hover:brightness-125 active:brightness-90 disabled:opacity-40 disabled:pointer-events-none transition-[filter] focus:outline-none focus-visible:ring-2";

export const DISCIPLINE_THEME = {
  logic: {
    id: "logic", base: "/academy/logic", available: true,
    accent: "#8fa3c8", light: "#b9c6de", panel: "#171c26",
    btn: "bg-[#2e3a50] text-[#e8edf5] shadow-[0_0_20px_rgba(143,163,200,0.18)]",
    frame: "border border-[#8fa3c8]/45 shadow-[0_0_28px_rgba(143,163,200,0.22)]",
    activeBg: "bg-[#2e3a50]/70 border-[#8fa3c8]",
    ring: "focus-visible:ring-[#8fa3c8]",
  },
  physics: {
    id: "physics", base: "/academy/physics", available: true,
    accent: "#7fb69a", light: "#bfdccb", panel: "#14211a",
    btn: "bg-[#2e5040] text-[#eaf5ee] shadow-[0_0_20px_rgba(127,182,154,0.18)]",
    frame: "border border-[#7fb69a]/45 shadow-[0_0_28px_rgba(127,182,154,0.22)]",
    activeBg: "bg-[#2e5040]/70 border-[#7fb69a]",
    ring: "focus-visible:ring-[#7fb69a]",
  },
  ethics: {
    id: "ethics", base: "/academy/ethics", available: true,
    accent: "#c86058", light: "#e8b8b2", panel: "#261415",
    btn: "bg-[#6b2a2a] text-[#f5e4e4] shadow-[0_0_20px_rgba(190,90,80,0.18)]",
    frame: "border border-[#c86058]/45 shadow-[0_0_28px_rgba(200,96,88,0.22)]",
    activeBg: "bg-[#6b2a2a]/70 border-[#c86058]",
    ring: "focus-visible:ring-[#c86058]",
  },
};

export const tpl = (s, vars = {}) =>
  Object.entries(vars).reduce((a, [k, v]) => a.replaceAll(`{${k}}`, String(v)), s || "");

const STRONG = ["Practised", "Integrated", "Independent", "Demonstrated", "Applied"];

/* Not started / In progress / Completed for one lesson record. */
export function lessonStatus(rec) {
  if (!rec) return "notStarted";
  if (STRONG.includes(rec.learningStatus)) return "completed";
  return "inProgress";
}

/* Resume target: first non-completed lesson in course order; null when all done. */
export function resumeTarget(course, records) {
  const all = (course?.phases || []).flatMap((p) => p.lessons.map((l) => ({ ...l, phaseSlug: p.slug })));
  for (const l of all) {
    const rec = records.find((r) => r.lessonSlug === l.slug);
    if (lessonStatus(rec) !== "completed") return l;
  }
  return null;
}

export function flatLessons(course) {
  return (course?.phases || []).flatMap((p) => p.lessons.map((l) => ({ ...l, phaseSlug: p.slug, phaseOrder: p.order })));
}
